import { render, staticRenderFns } from "./AvatarSidebar.vue?vue&type=template&id=b237d160&scoped=true"
import script from "./AvatarSidebar.vue?vue&type=script&lang=js"
export * from "./AvatarSidebar.vue?vue&type=script&lang=js"
import style0 from "./AvatarSidebar.vue?vue&type=style&index=0&id=b237d160&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b237d160",
  null
  
)

export default component.exports